import { SkeletonBox, SkeletonText, SkeletonCircle } from '../primitives';
import '../primitives/Skeletons.css';

const PlayerSkeleton = () => (
  <div
    aria-hidden="true"
    style={{
      display: 'flex',
      flexDirection: 'column',
      gap: 'var(--space-md)',
      padding: 'clamp(1.5rem, 4vw, 3rem)',
      maxWidth: '1040px',
      margin: '0 auto',
    }}
  >
    {/* Player surface (16:9) */}
    <div style={{ position: 'relative', width: '100%', aspectRatio: '16 / 9' }}>
      <SkeletonBox
        height="100%"
        width="100%"
        borderRadius="var(--radius-lg)"
        style={{ position: 'absolute', inset: 0 }}
      />
      {/* Center play button */}
      <div
        style={{
          position: 'absolute',
          inset: 0,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        }}
      >
        <SkeletonCircle size={84} />
      </div>
    </div>

    {/* Transport controls */}
    <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-sm)' }}>
      <SkeletonCircle size={40} />
      <SkeletonCircle size={40} />
      <SkeletonText widths={['44px']} lineHeight="14px" />
      <SkeletonBox height={6} borderRadius="999px" style={{ flex: 1 }} />
      <SkeletonText widths={['44px']} lineHeight="14px" />
      <SkeletonCircle size={40} />
    </div>

    {/* Title + meta */}
    <div style={{ display: 'flex', flexDirection: 'column', gap: '0.4rem' }}>
      <SkeletonText widths={['min(520px, 80%)']} lineHeight="24px" />
      <SkeletonText widths={['min(280px, 60%)']} lineHeight="14px" />
    </div>

    {/* Description */}
    <SkeletonText lines={3} widths={['100%', '94%', '70%']} lineHeight="16px" />

    {/* Action chips */}
    <div style={{ display: 'flex', gap: 'var(--space-sm)', flexWrap: 'wrap' }}>
      <SkeletonBox width={104} height={36} borderRadius="999px" />
      <SkeletonBox width={104} height={36} borderRadius="999px" />
      <SkeletonBox width={104} height={36} borderRadius="999px" />
    </div>
  </div>
);

export default PlayerSkeleton;
